<template>
    <div>
        <div id="MainHTML">
            <div>
                <p class="color1 text-2xl text-center"><center>Evaluación de {{setEvaluacion.libro.nombrelibro}}</center></p>
                <vs-divider></vs-divider>
                <p class="mt-3"><b class="color1">Disponible: </b> {{ setEvaluacion.fecha_inicio }} - {{ setEvaluacion.fecha_fin }}</p>
                <div class="mt-2">
                    <p class="mr-3"><b class="color1">Puntos:  </b> {{ setEvaluacion.puntaje }}</p>
                    <p class="mr-3"><b class="color1">Límite de tiempo: </b> {{ setEvaluacion.tiempo }} minutos</p>
                </div>
                <p class="mt-5 color2 tamanio1">
                    <b>Comentario del Profesor/a:</b> {{ setEvaluacion.indicaciones }}
                </p>
                <vs-divider class="mt-3"></vs-divider>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="vx-row" v-for="(item,key) in arrayQuestions" :key="key">
                        <div class="vx-col w-full mb-6">
                            <div class="flex bg1" style="justify-content: space-between;">
                                <p class="bg1 titulo">Pregunta {{ key + 1 }}</p>
                                <p class="bg1 titulo">{{ item.puntaje }} pts</p>
                            </div>
                            <p class="mt-5">{{ item.pregunta }}</p>
                            <!--imagen-->
                            <img v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+item.url" class="img-responsive mt-5" width="200" height="200" style="border-radius: 5px;">
                            <!--opciones-->
                            <vs-divider></vs-divider>
                            <!--pregunta abierta-->
                            <div v-if="item.id_tipo == idPreguntaAbierta">
                                <!--INPUT-->
                                <vs-input v-model="item.seleccionar" class="w-full mt-5" label="Respuesta" placeholder="Escribe tu respuesta aquí"></vs-input>
                            </div>
                            <!--pregunta columna-->
                            <div v-if="item.id_tipo == idPreguntaColumna">
                                <table style="width: 100%;" v-if="item.opciones.length > 0">
                                    <tr>
                                        <th>{{ item.columna1 }}</th>
                                        <th >{{ item.columna2 }}</th>
                                    </tr>
                                    <tr v-for="(tr, indexitem) in item.opciones" :key="indexitem" >
                                        <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                        <td style="background-color: #f2f2f2;width: 40%;">
                                            <p></p>
                                            <v-select :options="item.respuestasColumna"  :reduce="val => val" class="w-full" v-model="tr.seleccionar" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div v-else>
                                 <!--preguntas normales-->
                                <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                    <li class="my-2">
                                        {{ tr.respuesta }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
      return{
        arrayQuestions:[],
        idPreguntaAbierta:7,
        idPreguntaColumna:5,
      }  
    },
    props:{
        arrayPreguntas:{
            type:Array,
            default:function(){
                return []
            }
        },
        grupoSelect:{
            type:Number,
            default:0
        },
        setEvaluacion:{
            type:Object,
            default:function(){
                return {}
            }
        }
    },
    mounted(){
        let me = this;
        me.arrayQuestions   = me.arrayPreguntas
        me.exportarEvaluacion()
    },
    methods: {
        exportarEvaluacion(){
            let me = this;
            //NOTIFIFY
            me.$vs.notify({
                title: 'Exportando',
                text: 'Estamos exportando tu evaluación',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                time: 3000
            })
            //exportar despues de 2 segundos
            setTimeout(function(){
                me.ExportToDoc()
            },1000)
        },  
        ExportToDoc(){
            let me = this;
            let filename = ""
            filename = "Reporte de evaluacion"
            var HtmlHead = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
            var EndHtml = "</body></html>";
            //complete html
            var html = HtmlHead +document.getElementById("MainHTML").innerHTML+EndHtml;
            //specify the type
            var blob = new Blob(['\ufeff', html], {
                type: 'application/msword'
            });
            // Specify link url
            var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
            // Specify file name
            filename = filename?filename+'.doc':'document.doc';
            // Create download link element
            var downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            if(navigator.msSaveOrOpenBlob ){
                navigator.msSaveOrOpenBlob(blob, filename);
            }else{
                // Create a link to the file
                downloadLink.href = url;
                // Setting the file name
                downloadLink.download = filename;
                //triggering the function
                downloadLink.click();
            }
            document.body.removeChild(downloadLink);
            //emit al padre que termino de exportar 
            me.$emit('changeExport',true)
        },
    }
}
</script>